<!--购物车-->
<template>
  <div style="background: #f5f5f5; min-height: 100vh">
    <div class="header-row flex-between">
      <div v-if="!isEdit" @click="onEdit">管理</div>
      <div v-else @click="onEditComplete">完成</div>
    </div>
    <div style="height: 50px"></div>
    <div v-if="businessList.length == 0">
      <div class="empty-cart">
        <div class="empty-cart-back">
          <img
            style="width: 1.2rem; height: 1.2rem"
            src="https://img01.yzcdn.cn/vant/empty-image-default.png"
          />
        </div>
        <div class="empty-cart-des">购物车是空的，快去逛逛吧。</div>
      </div>
    </div>

    <div
      class="border-top"
      v-for="(order, bindex) in businessList"
      :key="bindex"
      v-if="!order.hidden"
    >
      <!-- <div class="row-title">
          <van-checkbox
                  style="margin-right:8px;"
                  v-model="order.checked"
                  checked-color="#07c160"
                  @click.native="onBusinessCheckChange(bindex, order.checked)"
          >
          </van-checkbox>
          <img class="row-title-img" :src="order.business_pic_url" alt="">
          {{order.business_name}}
      </div>-->
      <div
        v-if="!goods.hidden"
        class="flex-between cart-row-between"
        v-for="(goods, gindex) in order.goods_items"
        :key="gindex"
      >
        <div class="between-left flex-start">
          <van-checkbox
            style="margin-right: 8px"
            v-model="goods.checked"
            checked-color="#07c160"
            @change="onGoodsCheckChange(bindex, gindex, goods.checked)"
          ></van-checkbox>
          <img class="between-left-img" :src="goods.pic_url" alt />
          <div class="goods-box">
            <div class="between-left-title">{{ goods.title }}</div>
            <div
              class="between-left-detail gray-light"
              @click="onChangeSku(goods, bindex, gindex)"
            >
              {{ goods.sku_formart }}
            </div>
            <div class="between-left-price">¥{{ goods.price }}</div>
          </div>
        </div>

        <div class="between-right">
          <van-stepper
            v-model="goods.count"
            integer
            min="1"
            :max="goods.stock"
            @change="onGoodsCountChange(bindex, gindex, goods.count)"
          />
          <!--                    <div class="between-right-num gray-light"><span>数量</span> 1</div>-->
        </div>
      </div>
    </div>
    <div class v-for="(item, index) in contentList" :key="index">
      <goodsTabs
        v-if="item.type == 'goodsTabs1'"
        :content="item.content"
      ></goodsTabs>
    </div>

    <div style="height: 88px"></div>
    <div class="footer flex-between" v-if="!isEdit">
      <div class="footer-left">
        <div>
          <van-checkbox
            v-model="allChecked"
            checked-color="#07c160"
            @click.native="onAllCheckChange"
            >全选</van-checkbox
          >
        </div>
        <div class="flex-start">
          <div>总计</div>
          <div class="card-price">¥{{ totalPrice }}</div>
        </div>
        <!-- <span style='color:#999; font-size:10px; font-weight:normal'>不含运费</span> -->
      </div>
       <div class="footer-right-copy" v-if="!cart_id" v-clipboard:copy="row.url" v-clipboard:success="function(){copySuccess() }">分享</div>
      <div class="footer-right" @click="submit">去结算</div>
    </div>

    <div class="footer flex-between" v-else>
      <div class="footer-left footer-empty" @click="onEmpty">清空购物车</div>
      <div class="footer-delete" @click="onDelete">删除</div>
    </div>

    <!-- 底部导航 -->
    <!-- <TabBar :show-tab-bar="false"></TabBar> -->
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />

    <div class="sku-container">
      <van-sku
        v-model="showSkuPicker"
        :sku="skuData.sku"
        :goods="skuData.goods"
        :goods-id="skuData.goods_id"
        :quota="skuData.quota"
        :quota-used="skuData.quotaUsed"
        :custom-stepper-config="customStepperConfig"
        :hide-stock="skuData.hide_stock"
        :close-on-click-overlay="closeOnClickOverlay"
        :message-config="messageConfig"
        :show-add-cart-btn="false"
        :buy-text="'确认'"
        @buy-clicked="onBuyClicked"
      />
    </div>
  </div>
</template>
<style scoped>
.empty-cart {
  width: 7rem;
  height: 4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  margin: 10px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.empty-cart-back {
  width: 1.2rem;
  height: 1.2rem;
}

.empty-cart-des {
  margin-top: 32px;

  height: 14.5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}

.header-row {
  padding: 15px 15.5px;
  position: fixed;
  top: 0px;
  background: #fff;
  left: 0;
  right: 0;
  z-index: 1;
}

.row-title {
  padding: 10px 16.5px;
  border-bottom: 1px solid #efefef;
}

.border-top {
  border-top: 0.15rem solid #efefef;
}

.row-title {
  padding: 0.2rem 0.3rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #efefef;
}

.row-title-img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
}

.between-left-img {
  width: 1.1rem;
  height: 1.1rem;
  /*margin-left: 0.16rem;*/
  margin-right: 0.1rem;
}

.cart-row-between {
  padding: 0.2rem;
  margin: 0 0.2rem;
  border-radius: 5px;
  background: #fff;
  border-bottom: 1px solid #efefef;
}

/* .cart-row-between:last-of-type {
      border: none;
  } */

.between-left-detail {
  font-size: 11px;
  margin: 0.1rem 0;
  background: #f7f8fa;
  display: inline-block;
  padding: 0 0.1rem;
}

.between-left-price {
  color: #f05656;
}

.between-right-num span {
  font-size: 12px;
}

.between-right {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  height: 1.2rem;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  /*width: 375px;*/
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #fff;
  z-index: 8;
  /* padding:0 15px; */
}

.footer-left {
  width: 218px;
  font-size: 12px;
  color: #111111;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 15px;
}

.card-price {
  font-size: 17px;
  font-weight: bolder;
  margin-left: 5px;
}

.footer-empty {
  width: 157px;
  color: #666;
  font-size: 14px;
}

.footer-delete {
  width: 157px;
  background: #ff976a;
  color: #fff;
  text-align: center;
  border-top: 1px solid #ff976a;
}

.footer-right {
  width: 2rem;
  height: 35px;
  background: rgba(250, 74, 85, 1);
  border-radius: 10px;
  color: #fff;
  text-align: center;
  line-height: 35px;
  margin-right: 15px;
}

.footer-right-copy {
  width: 1.2rem;
  height: 35px;
  background: #F7F8FA;
  border-radius: 10px;
  color: #333;
  text-align: center;
  line-height: 35px;
  margin:0 .2rem;
}

.van-stepper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.van-stepper__minus,
.van-stepper__plus,
.van-stepper__input-wrapper {
  width: 25px !important;
  height: 25px !important;
  font-size: 11px;
  /*
     width: 40rpx !important;
     height: 30rpx !important;
     font-size: 16rpx;*/
}

.goods-box {
  /*width: 135px;*/
  width: 165px;
}

.van-stepper {
  width: 75px;
}

.van-stepper >>> input {
  width: 25px;
  height: 25px;
  margin: 0;
}
</style>

<script>
import TabBar from "@/components/TabBar.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import goodsTabs from "@/components/index/GoodsTabs.vue";

import Vue from "vue";
import { Stepper, Checkbox, Toast, Sku } from "vant";

export default {
  name: "Cart",
  components: {
    TabBar,
    [Checkbox.name]: Checkbox,
    [Stepper.name]: Stepper,
    [Sku.name]: Sku,
    Toast,
    LoginDialog,
    goodsTabs,
  },
  data: function () {
    return {
      loginShow: false,
      allChecked: true,
      isEdit: false,
      skuLoading: false,
      showSkuPicker: false,
      goods: {},

      businessList: [],
      totalPrice: 0,

      isAllButton: 1,
      isBusinessButton: 1,

      row: {},

      contentList: [],
      closeOnClickOverlay: true,
      showWxShare: false,
      messageConfig: {},
      cart_count: 0,
      customStepperConfig: {
        quotaText: "",
      },
      skuData: {
        sku: {
          none_sku: false, // 是否无规格商品
          hide_stock: false, // 是否隐藏剩余库存
          list: [],
          tree: [],
          messages: [],
        },
        goods: {},
        goods_id: 0,
        quota: 0,
        quotaUsed: 0,
      },

      bindex: 0,
      gindex: 0,
      cart_id: 0,
    };
  },
  filter: {},
  mounted() {
    document.title = "购物车";
    this.cart_id = this.$route.query.cart_id
    this.getCartDetail();
    this.loadList();
  },
  destroyed() {},
  methods: {
    loadList() {
      let that = this;
      this.$api.get(
        "/api/index/contentList",
        {
          page_id: 1,
          type: "goodsTabs1",
        },
        (res) => {
          that.contentList = res.data;
        }
      );
    },
    // 获取购物车所有数据
    getCartDetail: function () {
      let that = this;
      let cart_id = this.cart_id
      this.$api.get(
        "/api/cart/detail",
        {
          cart_id: cart_id
        },
        (res) => {
          that.row = res.data;
          that.businessList = res.data.list;
          that.totalPrice = res.data.total_price;
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    onChangeSku(goods, bindex, gindex) {
      let that = this;
      let sku = {};
      let total = 0;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      that.bindex = bindex;
      that.gindex = gindex;

      this.$api.get(
        "/api/cart/goodsDetail",
        {
          id: goods.goods_id,
        },
        (res) => {
          that.showSkuPicker = true;
          let data = res.data.data;
          that.detail = data;
          that.header = res.data.header;
          that.share = res.data.share;
          that.chat = res.data.chat;
          that.cart_count = res.data.h5_cart_count;

          that.skuData.sku = sku = res.data.sku;
          that.skuData.sku.messages = [];
          // that.business_id = res.data.data.business_id
          //
          // localStorage.setItem('_business_id', res.data.data.business_id)

          // 计算总图片数量
          // let count = 0,
          //   picCount = data.pics_url.length;
          // if (data.videos_url) {
          //   count++;
          // }
          // that.picCount = count + picCount;
          Toast.clear();
          that.loading = true;

          that.skuData.goods = {
            title: that.detail.title,
            picture: that.detail.pic_url,
          };

          // 总数量
          for (let i = 0; i < sku.list.length; i++) {
            total = total + sku.list[i].stock_num;
          }

          that.skuData.sku.stock_num = total;
          that.skuData.sku.price =
            that.detail.price_range[0] + "-" + that.detail.price_range[1];
          that.skuData.goods_id = that.detail.id;
          that.skuData.quota = that.detail.user_buy_limit;
          that.skuData.quotaUsed = that.detail.buy_count;
          if (that.skuData.quota > 0) {
            that.customStepperConfig.quotaText =
              "(每人限购" + that.skuData.quota + "件)";
          }
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    // 立即购买
    onBuyClicked(data) {
      let that = this;
      // 更换sku
      console.log(data);
      // data.sku_formart = 'hh'
      let bindex = that.bindex,
        gindex = that.gindex,
        sku_id = data.selectedSkuComb.id

      let skuDataRow = that.businessList[bindex].goods_items[gindex]
      skuDataRow.goods_id = data.goodsId;
      skuDataRow.sku_id = sku_id;
      skuDataRow.count = data.selectedNum;

      // 获取sku_formart
      let skuName = ''
      that.skuData.sku.tree.map(treeRow => {
        treeRow.v.map(attr => {
          console.log('treeRow.k_s', treeRow.k_s, data.selectedSkuComb)
          if(data.selectedSkuComb[treeRow.k_s] == attr.id) {
            skuName += attr.name + ' '
          }
        })
      })
      console.log('skuName', skuName)
      skuName.substr(0, 1, skuName.length)
      skuDataRow.sku_formart = skuName

      skuDataRow.price = data.selectedSkuComb.price / 100

      that.showSkuPicker = false
      that.priceCompute();
      /**
       * goods_id: that.businessList[bindex].goods_items[gindex].goods_id,
          sku_id: that.businessList[bindex].goods_items[gindex].sku_id,
          count: count,
       */

      // 判断是否修改数据库数据
      // that.onGoodsSkuChange(bindex, gindex, sku_id)

      return;

      let goods_items = [
        {
          goods_id: data.goodsId,
          sku_id: data.selectedSkuComb.id,
          count: data.selectedNum,
        },
      ];
      // 存入缓存
      localStorage.setItem(
        "order_check_goods_items",
        JSON.stringify(goods_items)
      );
      rbLink({
        name: "OrderCheck",
        query: JSON.stringify(goods_items),
      });
    },

    // 加入购物车
    onAddCartClicked(data) {
      let that = this;
      let goods_items = {
        goods_id: data.goodsId,
        sku_id: data.selectedSkuComb.id,
        count: data.selectedNum,
      };

      this.$api.post(
        "/api/cart/add",
        goods_items,
        (res) => {
          that.cart_count = that.cart_count + data.selectedNum;
          this.$toast("添加成功");
          that.showSkuPicker = false;
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
            that.showSkuPicker = false;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getCartDetail();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },

    // 全选和全不选
    onAllCheckChange() {
      let that = this;
      let change = !that.allChecked;

      that.businessList.map((business) => {
        business.checked = change;
        business.goods_items.map((goods) => {
          goods.checked = change;
        });
      });

      that.priceCompute();
    },

    onEdit: function () {
      let that = this;
      that.isEdit = true;
    },

    onEditComplete: function () {
      let that = this;
      that.isEdit = false;

      console.log(that.totalPrice);
    },

    // 改变基地的选中状态
    onBusinessCheckChange(bindex, status) {
      //改变goods选择状态
      console.log(status);
      let that = this;

      that.businessList[bindex].ckecked = !status;

      that.businessList[bindex].goods_items.map((goods) => {
        goods.checked = !status;
      });

      that.checkAllCheck();
      that.priceCompute();
    },

    // 改变商品的选中状态
    onGoodsCheckChange(bindex, gindex, status) {
      let that = this;
      that.businessList[bindex].goods_items.checked = status;

      //改变business全选状态
      if (
        that.businessList[bindex].goods_items.filter((goods) => {
          return goods.checked == false;
        }).length > 0
      ) {
        // console.log(that.businessList[bindex])

        that.businessList[bindex].checked = false;
      } else {
        that.businessList[bindex].checked = true;
      }
      that.checkAllCheck();
      that.priceCompute();
    },

    // 更改商品规格
    onGoodsSkuChange: function (bindex, gindex, sku_id) {
      let that = this;
      this.$api.get(
        "/api/cart/edit",
        {
          goods_id: that.businessList[bindex].goods_items[gindex].goods_id,
          sku_id: sku_id,
          count: that.businessList[bindex].goods_items[gindex].count,
        },
        (res) => {},
        (res) => {
          Toast(res.msg);
        }
      );

      that.priceCompute();
    },

    // 更改商品数量
    onGoodsCountChange: function (bindex, gindex, count) {
      let that = this;
      this.$api.get(
        "/api/cart/edit",
        {
          goods_id: that.businessList[bindex].goods_items[gindex].goods_id,
          sku_id: that.businessList[bindex].goods_items[gindex].sku_id,
          count: count,
        },
        (res) => {},
        (res) => {
          Toast(res.msg);
        }
      );

      that.priceCompute();
    },

    // 检查全选
    checkAllCheck() {
      //确定全选状态
      let that = this;
      if (
        that.businessList.filter((goods) => {
          return goods.checked == false;
        }).length > 0
      ) {
        // change事件自动触发 checkbox
        that.allChecked = false;
      } else {
        that.allChecked = true;
      }
    },

    // 计算价格
    priceCompute() {
      //计算价格
      let that = this;
      let totalPrice = 0;
      that.businessList.map((business) => {
        business.goods_items.map((goods) => {
          if (goods.checked) {
            totalPrice += goods.price * goods.count;
          }
        });
      });

      that.totalPrice = totalPrice;
    },

    // 删除数据
    onDelete() {
      let that = this;
      let goods_items = [];
      let businessList = that.businessList;

      // 获取选中的商品数据
      businessList.map((business, bindex) => {
        var deleteCount = 0;
        business.goods_items.map((goods, gindex) => {
          if (goods.checked) {
            goods_items.push(goods);
            businessList[bindex].goods_items[gindex].hidden = true;
            deleteCount++;
          }
        });
        if (deleteCount == businessList[bindex].goods_items.length) {
          businessList[bindex].hidden = true;
        }
      });
      this.$api.post(
        "/api/cart/removeList",
        { goods_items: goods_items },
        (res) => {}
      );

      // 问题出在 这里  无法将所有为hidden属性的商品给删除掉
      businessList.map((business, bindex) => {
        if (business.hidden) {
          businessList.splice(bindex, 1);
        }
        /*business.goods_items.map((goods, gindex) => {
                        if (goods.hidden) {
                            // business.goods_items.splice(gindex - k, 1);
                            // console.log(business)
                        }
                    });*/

        for (let i = 0; i < business.goods_items.length; ) {
          if (business.goods_items[i].hidden) {
            business.goods_items.splice(i, 1);
          } else {
            i++; //只有在没有删除元素时才对索引 i++
          }
        }
      });
      that.priceCompute();
      console.log(that.totalPrice);
    },
    // 清空购物车
    onEmpty() {
      let that = this;
      this.$api.post("/api/cart/removeAll", {}, (res) => {});

      that.businessList = [];
      that.priceCompute();
    },

    // 结算
    submit: function () {
      let that = this;
      let goods_items = [];
      let businessList = that.businessList;
      businessList.map((business, bindex) => {
        var deleteCount = 0;
        business.goods_items.map((goods, gindex) => {
          if (goods.checked) {
            goods_items.push({
              goods_id: goods.goods_id,
              sku_id: goods.sku_id,
              count: goods.count,
              properties:goods.properties,
              property_price:goods.property_price, 

            });
          }
        });
      });
      if (goods_items.length == 0) {
        Toast("请至少选择一款商品");
        return false;
      }
      localStorage.setItem(
        "order_check_goods_items",
        JSON.stringify(goods_items)
      );
      rbLink({
        name: "OrderCheck",
        // query: JSON.stringify(goods_items),
      });
      // this.$router.push({ path: "/ordercheck" });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Cart.vue?2d1c93ca